import React from 'react';

/** Consistent page title block: title, optional one-line context, optional actions on the right. */
const PageHeader: React.FC<{
    title: string;
    subtitle?: React.ReactNode;
    actions?: React.ReactNode;
}> = ({ title, subtitle, actions }) => (
    <header className="page-header">
        <div className="page-header-text">
            <h1 className="page-title">{title}</h1>
            {subtitle && <p className="page-subtitle">{subtitle}</p>}
        </div>
        {actions && <div className="page-actions">{actions}</div>}
    </header>
);

export default PageHeader;
